import React, { Component } from "react";
import PropTypes from "prop-types";
import AvatarEditor from "react-avatar-editor";
import Modal from "../Modal/Modal";
import Tooltip from "../Tooltip/Tooltip";

class EditImageModal extends Component {
	constructor(props) {
		super(props);
		this.initialState = {
			scale: 1,
		};
		this.state = { ...this.initialState };
		this.imageEditor = null;
	}

	onCloseModal = () => {
		const { closeModal } = this.props;
		this.setState({ ...this.initialState });
		closeModal();
	};

	/**
	 * Finds the cropped image from {@link imageEditor} and passes it to the prop method `successCallback`
	 * @param {Event} e The HTML event handled by this method
	 */
	handleOnSave = e => {
		e.preventDefault();
		const { successCallback } = this.props;
		if (this.imageEditor) {
			this.imageEditor.getImage().toBlob(blob => {
				successCallback(blob, this.imageEditor.getImage().toDataURL());
				this.imageEditor = null;
			});
			this.onCloseModal();
		}
	};

	/**
	 * Updates the scale value of the selected image
	 * @param {Event} e The HTML event handled by this method
	 */
	handleOnScaleImage = e => {
		const scale = parseFloat(e.target.value);
		this.setState({ scale });
	};

	setEditorRef = editor => {
		if (editor) this.imageEditor = editor;
	};

	render() {
		const { lang } = global;
		const { scale } = this.state;
		const { show, imageToEdit } = this.props;
		return (
			<Modal
				id="edit-image-modal"
				show={show}
				onHide={this.onCloseModal}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Edit Image")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12 text-center">
							<AvatarEditor
								ref={editor => this.setEditorRef(editor)}
								image={imageToEdit}
								width={155}
								height={155}
								border={50}
								color={[255, 255, 255, 0.6]} // RGBA
								scale={scale}
								rotate={0}
								disableDrop
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12 col-sm-8 col-sm-offset-2">
							<Tooltip content="zoom">
								<input
									name="scale"
									type="range"
									onChange={this.handleOnScaleImage}
									min="1"
									max="2"
									step="0.01"
									defaultValue="1"
								/>
							</Tooltip>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="row">
						<div className="col-xs-12">
							<button
								type="button"
								className="btn btn-primary"
								onClick={this.handleOnSave}
							>
								{lang.t("Save")}
							</button>
						</div>
					</div>
				</Modal.Footer>
			</Modal>
		);
	}
}

EditImageModal.propTypes = {
	show: PropTypes.bool,
	successCallback: PropTypes.func,
	closeModal: PropTypes.func,
	imageToEdit: PropTypes.string,
};

EditImageModal.defaultProps = {
	show: false,
	successCallback: () => {},
	closeModal: () => {},
	imageToEdit: "",
};

export default EditImageModal;
